export default {"src":"/_next/static/media/solid-js.ff51ab84.svg","height":18,"width":130};